import React, {Component} from 'react';

import {
    GENDER_MALE,
    GENDER_FEMALE,
    GENDER_COUPLE,
    GENDER_TRANSVESTITE
} from 'constants/genders'

import {dt} from 'l10n';

class GenderSelect extends Component {
    render() {
        let {name, value, onChange, showAllOption} = this.props;
        
        return (
            <select name={name} value={value} onChange={onChange}>
                {showAllOption && <option value="">{dt('gender_select', 'All')}</option>}
                <option value={GENDER_MALE}>{dt('gender_select', 'Male')}</option>
                <option value={GENDER_FEMALE}>{dt('gender_select', 'Female')}</option>
                <option value={GENDER_COUPLE}>{dt('gender_select', 'Couple')}</option>
                <option value={GENDER_TRANSVESTITE}>{dt('gender_select', 'Transvestite')}</option>
            </select>
        );
    }
}

GenderSelect.defaultProps = {
    showAllOption: false
};

export default GenderSelect;


// WEBPACK FOOTER //
// ./src/components/common/GenderSelect.js